var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormsAndResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.602,
    height: 104.572,
    viewBox: "0 0 92.602 104.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-secure-file-5893782",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16130",
    "data-name": "Path 16130",
    d: "M530.6,308.24c0-.2-.122-.3-.244-.493,0,0,0-.1-.122-.1a1.433,1.433,0,0,0-.365-.394l-30.461-24.663c-.122-.1-.366-.2-.487-.3,0,0-.122,0-.122-.1-.243-.1-.366-.1-.609-.2h-52.88c-4.021,0-7.311,2.663-7.311,5.919v92.734c0,3.256,3.29,5.919,7.311,5.919h77.98c4.021,0,7.311-2.663,7.311-5.919V308.24Zm-8.286-1.579H502.577a2.248,2.248,0,0,1-2.437-1.973V288.707Zm.975,75.963h-77.98a2.249,2.249,0,0,1-2.437-1.973V287.918a2.248,2.248,0,0,1,2.437-1.973h49.956v18.744c0,3.256,3.29,5.919,7.31,5.919h23.151v70.044A2.248,2.248,0,0,1,523.291,382.625Z",
    transform: "translate(-437.999 -281.999)",
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16131",
    "data-name": "Path 16131",
    d: "M512.821,365.642h33.853a2.821,2.821,0,0,0,0-5.642H512.821a2.821,2.821,0,0,0,0,5.642Z",
    transform: "translate(-496.722 -341.663)",
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16132",
    "data-name": "Path 16132",
    d: "M512.821,479.642h33.853a2.821,2.821,0,0,0,0-5.642H512.821a2.821,2.821,0,0,0,0,5.642Z",
    transform: "translate(-496.722 -442.963)",
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16133",
    "data-name": "Path 16133",
    d: "M566.489,588H512.26a2.891,2.891,0,0,0,0,5.642h54.23a2.891,2.891,0,0,0,0-5.642Z",
    transform: "translate(-493.073 -538.535)",
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16134",
    "data-name": "Path 16134",
    d: "M566.489,702H512.26a2.891,2.891,0,0,0,0,5.642h54.23a2.891,2.891,0,0,0,0-5.642Z",
    transform: "translate(-493.073 -634.107)",
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16135",
    "data-name": "Path 16135",
    d: "M566.489,816H512.26a2.891,2.891,0,0,0,0,5.643h54.23a2.891,2.891,0,0,0,0-5.643Z",
    transform: "translate(-493.073 -735.406)",
    fill: "#2c53bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsAndResources);
export default __webpack_public_path__ + "static/media/forms-and-resources.1cfdbeceeaadf04f7b4d8f56d853a0dc.svg";
export { ForwardRef as ReactComponent };